import { render, staticRenderFns } from "./DropDown.vue?vue&type=template&id=38db5c74&scoped=true&"
import script from "./DropDown.vue?vue&type=script&lang=js&"
export * from "./DropDown.vue?vue&type=script&lang=js&"
import style0 from "./DropDown.vue?vue&type=style&index=0&id=38db5c74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38db5c74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VDivider,VList,VListItem,VListItemTitle,VMenu})
